import { ReportSubCategory, ISortable } from './';

export class ReportCategory implements ISortable{
    public ReportCategoryId:string;

    public Name:string;

    public Description:string;

    public SortOrder:number;

    public IsDeleted:boolean;

    public ReportSubCategories:Array<ReportSubCategory>;

    constructor(ReportCategoryId:string = "", Name:string = ""){
        this.ReportCategoryId = ReportCategoryId;
        this.Name = Name;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/report-category.ts